module.exports = __webpack_public_path__ + "static/media/2009 - 10 Fonia Wong-min.ab4c9459.jpg";